/* ==========================================================================
   WADES — serum.js
   Loaded only on the serum product template, after belt.js. belt.js runs the
   gallery, the bundle picker, the sticky bar, the accordions and the reviews;
   this file adds what the serum page has that the others do not. The big
   price, the gallery badge and the sticky bar are rendered once in Liquid
   from pack 1 and never repainted (28 Sep 2026).
   ========================================================================== */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ============================================================
     2. TIMELINE + RESULT CARDS — draw in as they arrive.
        The stagger is in CSS (--i on each step); this only flips the class.
     ============================================================ */
  (function () {
    var targets = qsa('.sres__tl, .sres__rail, .sing__grid');
    if (!targets.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.18 });
    targets.forEach(function (t) { io.observe(t); });
  })();

  /* ============================================================
     3. "GOES WELL WITH" — after a one-tap add the row says so.
     ============================================================ */
  (function () {
    var rail = qs('[data-alarm-pairs]');
    if (!rail) return;
    rail.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      var row = form.closest('.pair');
      if (row) row.classList.add('is-added');
    });
  })();
})();
